import request from '@/utils/request'

/**
 * 获取宿舍抽签通道状态
 */
export function getDormitoryDrawChannel() {
  return request({
    url: '/v1/portal/dormitoryDraw/channel',
    method: 'get'
  })
}

/**
 * 获取宿舍抽签结果
 */
export function getDormitoryDraw() {
  return request({
    url: '/v1/portal/dormitoryDraw',
    method: 'get',
    silent: true
  })
}

/**
 * 请求宿舍抽签
 */
export function requestDormitoryDraw() {
  return request({
    url: '/v1/portal/dormitoryDraw',
    method: 'post'
  })
}
